import template from "./template-selector-page.html";

const TemplateSelectorPageComponent = {
  template: template,
  controller: class TemplateSelectorPageController {
    /* @ngInject */
    constructor($rootScope, $state, $q, $filter, QuoteTemplate, Notification, SweetAlertService, ModalsManager) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$q = $q;
      this.$filter = $filter;
      this.QuoteTemplate = QuoteTemplate;
      this.NotificationService = Notification;
      this.SweetAlertService = SweetAlertService;
      this.ModalsManager = ModalsManager;
    }

    $onInit() {
      this.loadingCustomTemplate = false;
      this.loadingImportedTemplates = false;
      this.quoteImportedTemplates = [];
      this.quoteCustomTemplates = [];

      this._refreshQuoteTemplates();
    }

    async createQuote(quoteTemplate, isImportedTemplate) {
      const options = { edit: false };

      if (quoteTemplate) {
        options.isImportedTemplate = isImportedTemplate;
        options.template = quoteTemplate._id;
        options.name = quoteTemplate.name;
        options.language = this.$rootScope.organization.settings.quoteLanguage;
        options.approveFromPublicView = this.$rootScope.organization.settings.approveFromPublicView;
        options.emailToCustomerOnAccept = this.$rootScope.organization.settings.emailToCustomerOnAccept;
        options.pdfDownloadable = this.$rootScope.organization.settings.pdfDownloadable;
        options.currency = quoteTemplate.currency;
        options.language = quoteTemplate.language;
      }

      const quote = await this.ModalsManager.openQuoteHeaderModal(options);
      if (quote) {
        this.$state.go("app.quoteEditor", { quoteId: quote._id });
      }
    }

    async deleteQuoteTemplate(quoteTemplate) {
      if (!(await this.SweetAlertService.templateWillBeDeleted())) {
        return;
      }
      await quoteTemplate.delete();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.quoteTemplateDeleted"),
      });
      this._refreshQuoteTemplates();
    }

    async deleteImportedQuoteTemplate(quoteTemplate) {
      if (!(await this.SweetAlertService.templateWillBeDeleted())) {
        return;
      }
      await quoteTemplate.deleteImported();
      this.NotificationService.success({
        title: this.$filter("trans")("notificationService.title.success"),
        message: this.$filter("trans")("notificationService.message.quoteTemplateDeleted"),
      });
      this._refreshQuoteTemplates();
    }

    async openQuoteTemplateImportModal() {
      if (await this.ModalsManager.openQuoteTemplateImportModal()) {
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.quoteTemplateImported"),
        });
        this._refreshQuoteTemplates();
      }
    }

    async openQuoteTemplateEditNameModal(quoteTemplate) {
      const quoteTemplateName = await this.ModalsManager.openQuoteTemplateEditNameModal(quoteTemplate.name);
      if (quoteTemplateName) {
        await quoteTemplate.editName(quoteTemplateName);
        this.NotificationService.success({
          title: this.$filter("trans")("notificationService.title.success"),
          message: this.$filter("trans")("notificationService.message.quoteTemplateRenamed"),
        });
        this._refreshQuoteTemplates();
      }
    }

    getTemplateFirstBackground(quoteTemplate) {
      const sectionsWithImages = quoteTemplate.sections.filter((section) => section.style.backgroundImage);

      if (sectionsWithImages.length > 0) {
        return {
          "background-image": `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3) ), url(${sectionsWithImages[0].style.backgroundImage})`,
        };
      } else {
        let backgroundColor;
        switch (quoteTemplate.sections[0].style.backgroundColorType) {
          case "primary":
            backgroundColor = this.$rootScope.organization.branding.header1.color;
            break;
          case "secondary":
            backgroundColor = this.$rootScope.organization.branding.header2.color;
            break;
          case "none":
            backgroundColor = "#FFFFFF00";
            break;
          case "custom":
            backgroundColor = quoteTemplate.sections[0].style.backgroundColor;
            break;
        }
        return { "background-color": backgroundColor };
      }
    }

    async openQuoteTemplateShareModal(quoteTemplate) {
      await this.ModalsManager.openQuoteTemplateShareModal(quoteTemplate, false);
    }

    _refreshQuoteTemplates() {
      this.loadingCustomTemplate = true;
      this.loadingImportedTemplates = true;

      this.$q.all({
        customTemplatesPromise: this.QuoteTemplate.query().then((customTemplatesPromise) => {
          this.quoteCustomTemplates = customTemplatesPromise;
          this.loadingCustomTemplate = false;
        }),
        importedTemplatesPromise: this.QuoteTemplate.getImportedTemplates().then((importedTemplatesPromise) => {
          this.quoteImportedTemplates = importedTemplatesPromise;
          this.loadingImportedTemplates = false;
        }),
      });
    }
  },
};

export default TemplateSelectorPageComponent;
